import { html, nothing } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';

/** Background work shown above the footer, e.g. an offline download. */
export type DataViewFooterProgress = {
  label: string;
  /** Completed share between 0 and 1. */
  ratio: number;
};

/** Overlay over the bottom of the view body; its zero-height anchor keeps
 * the frame height unchanged (styles in data-view.ts). */
export function renderDataViewFooterProgress(
  progress: DataViewFooterProgress | null | undefined
) {
  if (!progress) return nothing;
  const percent = Math.round(Math.min(1, Math.max(0, progress.ratio)) * 100);
  return html`<div data-data-view-footer-progress-anchor="true">
    <div role="status" aria-live="polite" data-data-view-footer-progress="true">
      ${progress.label}
      <div data-data-view-footer-progress-track="true">
        <div
          data-data-view-footer-progress-bar="true"
          style=${styleMap({ width: `${percent}%` })}
        ></div>
      </div>
    </div>
  </div>`;
}
